import React, { useState } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../action";
import "../../assets/emailAndGoogle.scss";
import { ReactComponent as HeadImg } from "../../assets/icons/headImg.svg";
import { ReactComponent as Jingge } from "../../assets/icons/jingge.svg";
import InitState from "./component/InitState";
import EmailLogin from "./component/EmailLogin";
import ForgetPassword from "./component/ForgetPassword";
import ResetPassword from "./component/ResetPassword";
import Security from "./component/Security";
import SignUpEmail from "./component/SignUpEmail";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import sentGAEvent from "@/ga";
import { useEffect } from "react";
const LoginComponent = (props) => {
  const [step, setStep] = useState(1);
  const reducerData = useSelector((state) => state.userinfo);
  const dispatch = useDispatch();
  const { signUpModal } = reducerData;
  const handleCancel = () => {
    keepAliveData({});
    dispatch(
      actions.onSignUpModal({
        visible: false,
      })
    );
    sentGAEvent({
      category: "Subscribe",
      action: "SubscribePrompt_Close_Click",
    });
  };

  const keepAliveData = (obj) => {
    dispatch(
      actions.keepAliveData(obj)
    )
  }

  useEffect(() => {
    console.log(signUpModal.counts)
    if (signUpModal.step === 6) {
      setStep(6);
    }
    if (signUpModal.step === 2) {
      setStep(2);
    }

  }, [signUpModal])


  return (
    <Modal
      className="signUpModal"
      //bodyStyle={{ padding: 0, width: 548, paddingBottom: 50 }}
      centered
      maskClosable={false}
      visible={signUpModal.visible}
      title={null}
      footer={null}
      afterClose={() => setStep(1)}
      onCancel={() => handleCancel()}
    >
      <HeadImg className="headImg" />
      <Jingge className="jingge" />
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={step}
          // timeout={500}
          addEndListener={(node, done) =>
            node.addEventListener("transitionend", done, false)
          }
          unmountOnExit={true}
          classNames="fade"
        >
          {step === 1 ? (
            <div key="initState">
              <InitState changeStep={setStep} />
            </div>
          ) : step === 2 ? (
            <div key="emailLogin">
              <EmailLogin changeStep={setStep} />
            </div>
          ) : step === 3 ? (
            <div key="signUpEmail">
              <SignUpEmail changeStep={setStep} />
            </div>
          ) : step === 4 ? (
            <div key="forgetPassword">
                    <ForgetPassword keepAliveData={keepAliveData} changeStep={setStep} />
            </div>
          ) : step === 5 ? (
            <div key="resetPassword">
              <ResetPassword changeStep={setStep} />
            </div>
          ) : step === 6 ? (
            <div key="security">
              <Security changeStep={setStep} />
            </div>
          ) : (
            ""
          )}
        </CSSTransition>
      </SwitchTransition>
    </Modal>
  );
};

export default LoginComponent;
